import { FetchContext } from '../fetch-context';
import { Notification } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getNotifications: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<Notification[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/notifications`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Notification[]>(fetchContext.errorStore, response, 'get notifications'));
